var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{ref:"hiddenLink",staticStyle:{"display":"none"},attrs:{"href":_vm.url,"target":"_blank"}})])}
var staticRenderFns = []

export { render, staticRenderFns }